// Services.jsx
import React from "react";
import Slideshow from "./Slideshow";
import "./Services.css";

export default function Services({ onOpenContact }) {  // Add onOpenContact prop
  return (
    <section id="services" className="services-section">
      <div className="services-main">
        <h2 className="services-title">Professional Painting Services</h2>
        <div className="services-description">
          <p className="services-intro">
            At ARELY CONSTRUCTION & PAINTING LLC, we deliver premium painting services 
            throughout Roanoke, VA and surrounding areas including Christiansburg, 
            Lynchburg, Harrisonburg, Troutville, Salem, Blacksburg, Floyd, Pulaski, 
            and Radford. With years of experience and dedication to quality, we 
            transform spaces with precision and expertise.
          </p>
          <div className="painting-services-list">
            <div className="service-type">
              <h3>Residential Painting</h3>
              <p>Interior and exterior painting for homes, featuring premium materials 
                and expert color consultation. We ensure precise preparation, proper 
                protection of your property, and flawless execution.</p>
            </div>
            <div className="service-type">
              <h3>Commercial Painting</h3>
              <p>Professional painting solutions for businesses, offices, retail spaces, 
                and industrial facilities. We work efficiently to minimize disruption 
                to your operations while delivering outstanding results.</p>
            </div>
            <div className="service-type">
              <h3>New Construction</h3>
              <p>Comprehensive painting services for new construction projects, working 
                closely with contractors and developers to meet deadlines and exceed 
                quality expectations.</p>
            </div>
          </div>
        </div>
        <Slideshow />
      </div>

      <div className="other-services-section">
        <h2 className="services-title">Other Services</h2>
        <div className="other-services-container">
          <div className="service-card">
            <div className="service-image-container">
              <img
                src="https://arely-media.s3.us-east-1.amazonaws.com/Construction+and+renovation+services.jpg"
                alt="Construction and renovation services"
                className="service-image"
              />
            </div>
            <div className="service-content">
              <h3>Construction & Renovation</h3>
              <p>Expert construction and renovation services for both residential and 
                commercial properties. Our team specializes in:</p>
              <ul>
                <li>Complete home renovations</li>
                <li>Kitchen and bathroom remodeling</li>
                <li>Flooring installation</li>
                <li>Custom carpentry</li>
                <li>Structural improvements</li>
              </ul>
              <button className="service-cta" onClick={onOpenContact}>Request Quote</button>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}